import { useTranslation } from 'react-i18next';
import { HeaderCobalt } from '../common/HeaderCobalt';
import { Link } from 'react-router-dom';
import { ROUTE_INFO } from '../route/Route.constants';

interface PageNotFoundProps {
  homepageRedirectUrl?: string;
}

export default function PageNotFound({
  homepageRedirectUrl,
}: PageNotFoundProps) {
  const [translate] = useTranslation();
  const redirectUrl = homepageRedirectUrl || ROUTE_INFO.homePage.path;
  return (
    <div className="w-screen bg-white items-center flex flex-col">
      <div className="px-27px sm:w-full 2xl:w-1440px">
        <HeaderCobalt />
      </div>
      <div className="flex flex-col items-center self-center pt-32 w-screen h-screen bg-filter-report">
        <div className="text-130px text-white">404</div>
        <div className="text-white text-22px">
          {translate('PAGE_NOT_FOUND')}
        </div>
        <div className="text-white text-14px mt-5">
          {translate('PAGE_NOT_FOUND_DESC')}
        </div>
        <Link to={redirectUrl}>
          <div className="px-4 py-3 rounded-2px border border-white flex items-center justify-center mt-14 cursor-pointer">
            <div className="text-white text-14px font-bold">
              {translate('PAGE_NOT_FOUND_CTA')}
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
}
